import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getSkuDetails } from "../../services/sku";
import { skuDetailsMapper } from "../../helpers/dataMapper";
import { SKU_DETAILS_CRUMBS } from "../../constants/crumbs";
import PortalBreadcrumb from "../UI/Breadcrumb/PortalBreadcrumb/PortalBreadcrumb";
import Loading from "../UI/Loading/Loading";
import EmptyContent from "../UI/EmptyContent/EmptyContent";
import SkuBundleDetails from "../SkuBundleDetails/SkuBundleDetails";
import SkuCarsFitment from "./SkuCarsFitment/SkuCarsFitment";
import RelevantSkusSlider from "./RelevantSkusSlider/RelevantSkusSlider";
import SubstituteSkusSlider from "./SubstituteSkusSlider/SubstituteSkusSlider";
import classes from "./SkuDetails.module.css";

const SkuDetails = () => {
  const [skuDetails, setSkuDetails] = useState();
  const [carsFitment, setCarsFitment] = useState([]);
  const [isSkuDetailsLoading, setIsSkuDetailsLoading] = useState(true);
  const [skuDetailsError, setSkuDetailsError] = useState("");
  const pathParams = useParams();
  const skuId = Number(pathParams.skuId);

  useEffect(() => {
    const fetchSkuDetails = async () => {
      try {
        setIsSkuDetailsLoading(true);
        setSkuDetailsError("");
        const response = await getSkuDetails(skuId);
        const {
          data: { data: skuDetails },
        } = response;
        const { details, cars } = skuDetailsMapper(skuDetails);
        setSkuDetails(details);
        setCarsFitment(cars);
      } catch (err) {
        setSkuDetailsError("حدث خطأ أثناء تحميل تفاصيل المنتج !");
      } finally {
        setIsSkuDetailsLoading(false);
      }
    };

    if (skuId) {
      fetchSkuDetails();
    } else {
      setIsSkuDetailsLoading(false);
      setSkuDetailsError("عفواً لا يوجد تفاصيل لعرضها !");
    }
  }, [skuId]);

  return (
    <div className={classes["sku-details-wrapper"]}>
      <PortalBreadcrumb paths={SKU_DETAILS_CRUMBS} />
      {isSkuDetailsLoading ? (
        <Loading className={classes["sku-details__loading"]} />
      ) : skuDetailsError ? (
        <EmptyContent
          className={classes["sku-details__empty"]}
          message={"لا يوجد تفاصيل لعرضها !"}
        />
      ) : (
        <>
          <SkuBundleDetails
            details={{ ...skuDetails, id: skuId }}
            isDetailsForSku={true}
          />
          <SkuCarsFitment carsFitment={carsFitment} />
          <div className={classes["sku-details__sliders-container"]}>
            <RelevantSkusSlider skuId={skuId} />
            <SubstituteSkusSlider skuId={skuId} />
          </div>
        </>
      )}
    </div>
  );
};

export default SkuDetails;
